import { Alert, Box, Typography } from '@mui/material';

import { ExportIncomeForm } from './ExportIncomeForm';

const ExportIncome = () => {
  return (
    <Box mt={6}>
      <Typography fontWeight={800}>
        โครงสร้างรายได้จากในประเทศและจากต่างประเทศ
      </Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        คำชี้แจง: กรณีมีรายได้จากต่างประเทศ กรุณาแจกแจงรายได้เป็นรายประเทศ
        (ถ้ามี)
      </Alert>
      <ExportIncomeForm />
    </Box>
  );
};

export default ExportIncome;
